import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/utils';
let editor = DefaultVariableTextEditor;
/**
 * Register a custom text-editor implementation at app boot — the admin
 * registers one that wraps VariableAutocompleteTextarea so `{{` opens the
 * variable picker. Any consumer that does not register falls through to the
 * plain textarea below.
 */
export function setVariableTextEditor(next) {
    editor = next;
}
export function getVariableTextEditor() {
    return editor;
}
/**
 * Plain textarea fallback. Used by playground and tests. The admin overrides
 * this with VariableAutocompleteTextarea via `setVariableTextEditor`.
 */
function DefaultVariableTextEditor({ value, onValueChange, onKeyDown, onPaste, onFocus, onBlur, placeholder, className, rows = 1, id, name, dataFormItemId, textareaRef, }) {
    return (_jsx("textarea", { ref: textareaRef, id: id, name: name, "data-form-item-id": dataFormItemId, rows: rows, value: value, onChange: event => onValueChange(event.target.value), onKeyDown: onKeyDown, onPaste: onPaste, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder, className: cn('flex-1 min-w-0 resize-none bg-transparent outline-none text-xs leading-relaxed placeholder:text-muted-foreground selection:bg-primary/25 selection:text-foreground py-0.5', className) }));
}
//# sourceMappingURL=VariableTextEditor.js.map